import { getColor } from '../utils';

import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const PushOpen = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 24 24" {...props}>
    <path
      d="M13.6875 14.8125V18.3885C13.6875 18.6576 13.6345 18.9241 13.5315 19.1728C13.4284 19.4214 13.2774 19.6473 13.0871 19.8376C12.8967 20.0279 12.6708 20.1788 12.4221 20.2817C12.1734 20.3847 11.9069 20.4376 11.6378 20.4375H6.73725C6.46811 20.4376 6.20158 20.3847 5.9529 20.2817C5.70422 20.1788 5.47825 20.0279 5.2879 19.8376C5.09756 19.6473 4.94656 19.4214 4.84354 19.1728C4.74052 18.9241 4.6875 18.6576 4.6875 18.3885V6.73725C4.6875 6.19362 4.90346 5.67226 5.28786 5.28786C5.67226 4.90346 6.19362 4.6875 6.73725 4.6875H8.0625"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.6875 17.0625H13.6875"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.4368 7.9375C18.4368 8.82752 18.1728 9.69755 17.6784 10.4376C17.1839 11.1776 16.4811 11.7544 15.6588 12.095C14.8366 12.4356 13.9318 12.5247 13.0589 12.351C12.1859 12.1774 11.3841 11.7488 10.7548 11.1195C10.1255 10.4901 9.69687 9.68832 9.52324 8.81541C9.3496 7.94249 9.43872 7.03769 9.77931 6.21542C10.1199 5.39316 10.6967 4.69035 11.4367 4.19589C12.1767 3.70142 13.0468 3.4375 13.9368 3.4375"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.4368 4.5625L14.3342 8.66425C14.282 8.71652 14.22 8.75799 14.1517 8.78628C14.0834 8.81457 14.0103 8.82913 13.9364 8.82913C13.8625 8.82913 13.7893 8.81457 13.721 8.78628C13.6528 8.75799 13.5907 8.71652 13.5385 8.66425L12.25 7.375"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
